import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiMail, FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaMailBulk, FaStar } from 'react-icons/fa';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from 'src/hooks/Modal';
import sleep from 'src/utils/sleep';
import { Form } from '@unform/web';
import Input from 'src/pages/DashboardPages/core/components/Forms/Input';
import SelectSimple from 'src/pages/DashboardPages/core/components/Forms/SelectSimple';


interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule({

  lineData,

}: ICreateModule): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();


  const sendMail = async (data) => {
    addLoading({ title: 'Carregando', key: 'loading' })
    try {

      await api.post(`resend-invitation-to-sponsors/${lineData?.hash}/${data?.reference}`)
      removeLoading('loading');
      addToast({ title: 'Enviado com sucesso', type: 'success' });
      removeModal('modal')
    }
    catch (err) {
      addToast({ title: err?.response?.data?.message || 'Erro ao enviar', type: 'error' });
      removeLoading('loading');
    }

  }


  const sendMailCheck = () => {

    addModal({
      title: '', key: 'modal', theme: 'whiteModalMedium', content: <>
        <h2 style={{ color: '#333', fontSize: '#333', width: '100%', textAlign: 'center' }}>Confirmar envio?</h2>

        <Form onSubmit={sendMail}   >

          <Input name="reference" placeholder="Referência" />
          <button className='greenButton2' style={{ margin: '10px auto' }}   >Enviar</button>

        </Form>

      </>
    })

  }




  const moduleUpdate = (data: Record<string, any>): JSX.Element => (
    <>
      <button className='lineIcon' title='Reenviar para patrocinador' onClick={() => { sendMailCheck() }}><FaMailBulk /></button>


    </>
  );

  return moduleUpdate(lineData);
}
